import { createFileRoute } from "@tanstack/react-router";
import { GeneralPage } from "../../../components/settings/general-page";

export const Route = createFileRoute("/_authenticated/_workspace/settings/general")({
  component: GeneralPage,
});
